<div class="rate">
    <svg width="13" height="13" *ngIf="star1 == true"><use xlink:href="#star_light" ></use></svg>
    <svg width="13" height="13" *ngIf="star1 == false"><use xlink:href="#star"></use></svg>


    <svg width="13" height="13" *ngIf="star2 == true"><use xlink:href="#star_light" ></use></svg>
    <svg width="13" height="13" *ngIf="star2 == false"><use xlink:href="#star"></use></svg>


    <svg width="13" height="13" *ngIf="star3 == true"><use xlink:href="#star_light" ></use></svg>
    <svg width="13" height="13" *ngIf="star3 == false"><use xlink:href="#star"></use></svg>


    <svg width="13" height="13" *ngIf="star4 == true"><use xlink:href="#star_light" ></use></svg>
    <svg width="13" height="13" *ngIf="star4 == false"><use xlink:href="#star"></use></svg>


    <svg width="13" height="13" *ngIf="star5 == true"><use xlink:href="#star_light" ></use></svg>
    <svg width="13" height="13" *ngIf="star5 == false"><use xlink:href="#star"></use></svg>
</div>


// WEBPACK FOOTER //
// ./src/app/shared-components/star-component.html